export const taxRateByState = {
    AL: 0.43,
    AK: 1.21,
    AS: 0, //American Samoa
    AZ: 0.84,
    AR: 0.62,
    CA: 0.81,
    CO: 0.62,
    CT: 1.91,
    DE: 0.53,
    DC: 0.57,
    FM: 0, //Federated States Of Micronesia
    FL: 1.10,
    GA: 0.96,
    GU: 0, //Guam
    HI: 0.28,
    ID: 0.77,
    IL: 2.25,
    IN: 0.88,
    IA: 1.47,
    KS: 1.41,
    KY: 0.84,
    LA: 0.48,
    ME: 1.27,
    MH: 0, //Marshall Islands
    MD: 1.08,
    MA: 1.18,
    MI: 1.83,
    MN: 1.19,
    MS: 0.78,
    MO: 1.00,
    MT: 0.87,
    NE: 1.88,
    NV: 0.92,
    NH: 2.10,
    NJ: 2.29,
    NM: 0.72,
    NY: 1.58,
    NC: 0.85,
    ND: 1.22,
    MP: 0, //Northern Mariana Islands,
    OH: 1.55,
    OK: 0.87,
    OR: 1.08,
    PW: 0, //Palau
    PA: 1.51,
    PR: 0, //Puerto Rico
    RI: 1.61,
    SC: 0.57,
    SD: 1.36,
    TN: 0.75,
    TX: 1.93,
    UT: 0.69,
    VT: 1.72,
    VI: 0, //Virgin Islands
    VA: 0.80,
    WA: 1.08,
    WV: 0.59,
    WI: 1.97,
    WY: 0.62,
}
function calPMI(loanRate, loanYear) {
    if (loanRate >= 0.9001 && loanRate <= 1 && loanYear === 30) {
        return 0.0062;
    }
    if (loanRate >= 0.9001 && loanRate <= 1 && loanYear === 20) {
        return 0.005867;
    }
    if (loanRate >= 0.9001 && loanRate <= 1 && loanYear === 15) {
        return 0.0057;
    }
    if (loanRate >= 0.8501 && loanRate <= 0.9 && loanYear === 30) {
        return 0.0044;
    }
    if (loanRate >= 0.8501 && loanRate <= 0.9 && loanYear === 20) {
        return 0.004067;
    }
    if (loanRate >= 0.8501 && loanRate <= 0.9 && loanYear === 15) {
        return 0.0039;
    }
    if (loanRate >= 0.8 && loanRate <= 0.85 && loanYear === 30) {
        return 0.0027;
    }
    if (loanRate >= 0.8 && loanRate <= 0.85 && loanYear === 20) {
        return 0.002367;
    }
    if (loanRate >= 0.8 && loanRate <= 0.85 && loanYear === 15) {
        return 0.0022;
    }
    return 0;

}
export function getMonthPay(options) {
    let homePrice = 0,
        downpayment = 0,
        downpaymentEquity = 0,
        downpaymentRate = 25,
        propertyTax = 0,
        propertyTaxRate = 0,
        propertyHoafee = 0,
        interestRate = 0,
        homeInsurance = 0,
        loanYear = 30,
        hasDPChanged = false,
        hasTaxValChanged = false,
        hasPropertyTax = true,
        hasHOADues = true,
        state = '';

    if (options.homePrice >= 0) {
        homePrice = Math.round(options.homePrice);
    }
    if (options.downpayment >= 0) {
        downpayment = Math.round(options.downpayment);
    }
    if (options.downpaymentEquity >= 0) {
        downpaymentEquity = Math.round(options.downpaymentEquity);
    }
    if (options.propertyTax >= 0) {
        propertyTax = Math.round(options.propertyTax);
    }
    if (options.propertyTaxRate >= 0) {
        propertyTaxRate = options.propertyTaxRate;
    }
    if (options.propertyHoafee >= 0) {
        propertyHoafee = Math.round(options.propertyHoafee);
    }
    if (options.interestRate >= 0) {
        interestRate = Math.round(options.interestRate);
    }
    if (options.homeInsurance >= 0) {
        homeInsurance = Math.round(options.homeInsurance);
    }
    if (options.loanYear >= 0) {
        loanYear = Math.round(options.loanYear);
    }

    if (options.downpaymentRate >= 0) {
        downpaymentRate = Math.round(options.downpaymentRate);
    }
    if (options.hasDPChanged === true || options.hasDPChanged === false) {
        hasDPChanged = options.hasDPChanged;
    }
    if (options.hasTaxValChanged === true || options.hasTaxValChanged === false) {
        hasTaxValChanged = options.hasTaxValChanged;
    }
    if (options.hasPropertyTax === true || options.hasPropertyTax === false) {
        hasPropertyTax = options.hasPropertyTax;
    }
    if (options.hasHOADues === true || options.hasHOADues === false) {
        hasHOADues = options.hasHOADues;
    }
    if (options.state) {
        state = options.state;
    }

    if (downpayment > homePrice) {
        downpayment = homePrice;
        downpaymentEquity = 0;
    }
    if (propertyTax > homePrice) {
        propertyTax = homePrice;
    }
    if (state && taxRateByState[state] && !propertyTaxRate) {
        propertyTaxRate = taxRateByState[state];
    }
    let totalPrice = homePrice; //Property Price
    downpayment = hasDPChanged ? downpayment : Math.round((homePrice * downpaymentRate) / 100) - downpaymentEquity;
    propertyTax = hasTaxValChanged ? propertyTax : Math.round((homePrice * propertyTaxRate) / 100);
    propertyTaxRate = hasPropertyTax ? propertyTaxRate / 100 || 0 : 0; //Property Tax Rate
    propertyHoafee = hasHOADues ? propertyHoafee || 0 : 0; //HOA fees
    //calculations
    let loanMonth = loanYear * 12; //Terms (mth)
    let interestMonthRate = interestRate / 100 / 12; //Monthly Interest Rate
    let loanAmount = totalPrice - downpayment - downpaymentEquity; //Loan Amount
    loanAmount = loanAmount > 0 ? loanAmount : 0;
    let taxAnnualAmount = propertyTaxRate * totalPrice; //Annual Property Tax
    let loanRate = loanAmount / totalPrice; //LTV(loan to value ratio)
    let PMI = downpaymentRate >= 20 ? 0 : calPMI(loanRate, loanYear); //PMI Private mortgage insurance, downpayment > 20% , could wavie the fee
    let pmiAnnualFee = PMI * loanAmount; //Annual Private Mortgage

    // output
    let result = {};
    result.downpayment = hasDPChanged ? downpayment : Math.round((homePrice * downpaymentRate) / 100) - downpaymentEquity;
    result.propertyTax = propertyTax;
    let _l = Math.pow(1 + interestMonthRate, loanMonth);
    result.ltv = loanRate;
    result.loanAmount = loanAmount;
    result.loanPerMonth = Math.round((loanAmount * (interestMonthRate * _l)) / (_l - 1)); //Loan/mth
    result.taxPerMonth = Math.round(taxAnnualAmount / 12); //Property Tax/mth
    result.hoaPerMonth = Math.round(propertyHoafee); //HOA/mth
    result.pmiPerMonth = Math.round(pmiAnnualFee / 12); //Private Mortgage Insurance/mth
    result.homeInsurancePerMonth = Math.round(homeInsurance / 12);
    result.monthTotal = result.loanPerMonth + result.taxPerMonth + result.hoaPerMonth + result.homeInsurancePerMonth + result.pmiPerMonth;
    return result;
}
